/**
 * AI PROXY SERVICE
 * 
 * This service routes all Gemini AI requests through our secure Express backend.
 * This prevents the GEMINI_API_KEY from being leaked to the public browser.
 */

export interface ChatMessage {
  role: 'user' | 'model';
  parts: { text: string }[];
}

export const aiProxy = {
  /**
   * Generates content using the backend proxy
   */
  generateContent: async (options: {
    model?: string;
    contents: ChatMessage[];
    config?: any;
  }) => {
    try {
      const response = await fetch('/api/ai/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(options),
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || `Server Error: ${response.status}`);
      }

      const data = await response.json();
      return data.text;
    } catch (error) {
      console.error("[AI PROXY ERROR]", error);
      throw error;
    }
  },

  /**
   * Generates embeddings using the backend proxy
   */
  embedContent: async (options: {
    model?: string;
    content: string;
  }) => {
    try {
      const response = await fetch('/api/ai/embed', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: options.model,
          content: { parts: [{ text: options.content }] }
        }),
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || `Server Error: ${response.status}`);
      }

      const data = await response.json();
      return data.values; // Returns number[]
    } catch (error) {
      console.error("[EMBED PROXY ERROR]", error);
      throw error;
    }
  }
};
